<template>
    <div class="p-2">
        <AnalyticsTypeSwitcher
            v-model="currentAnalyticsType"
            :current-analytics-type="currentAnalyticsType"
            @update:modelValue="currentAnalyticsType = $event"
        />
        <div class="mt-2">
            <ClientBirthdays v-if="currentAnalyticsType === 1" />
            <TrainerBirthdays v-if="currentAnalyticsType === 2" />
            <InactiveClients v-if="currentAnalyticsType === 3" />
        </div>
    </div>
</template>


<script>
import AnalyticsTypeSwitcher from '../../components/Analytics/AnalyticsTypeSwitcher.vue';
import ClientBirthdays from '../../components/Analytics/Birthdays/ClientBirthdays.vue';
import TrainerBirthdays from '../../components/Analytics/Birthdays/TrainerBirthdays.vue';
import InactiveClients from '../../components/Analytics/InactiveClients.vue';
export default {
    name: "AnalyticsMain",
    components: {
        ClientBirthdays,
        AnalyticsTypeSwitcher,
        TrainerBirthdays,
        InactiveClients
    },
    data: function () {
        return {
            currentAnalyticsType: 1
        }
    },
    methods: {
        
    },
    watch: {
        currentAnalyticsType: function (val) {
            console.log(val);
        }
    }
}
</script>

<style scoped>
</style>